module.exports = __webpack_public_path__ + "img/logo.fdbd0c9f.png";